import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { Perfil } from '@interfaces/interface-bakend/seguridad/acl/perfil.interface';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';

@Component({
    selector: 'app-rol-edicion',
    templateUrl: './rol-edicion.component.html',
    styleUrls: ['./rol-edicion.component.scss'],
})
export class RolEdicionComponent implements OnInit, OnDestroy {

    form: FormGroup;
    perfil: Perfil | null = null;
    flagLoaded: boolean = false;
    modoCreacion: boolean = true;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private perfilesService: PerfilesService,
        private modalCustom: PopUpModalCustomService,
    ) {
        this.form = this.fb.group({
            key: ['', [Validators.required, Validators.pattern(/^[A-Z_]+$/)]],
            descripcion: [''],
        });
    }

    ngOnDestroy(): void {
        this.modalCustom.cerrar();
    }

    ngOnInit(): void {
        this.perfil = this.perfilesService.getPerfilSeleccionado();
        this.modoCreacion = !this.perfil;

        if (!this.modoCreacion && this.perfil) {
            this.form.patchValue({
                key: this.perfil.key,
                descripcion: this.perfil.descripcion || '',
            });
        }

        this.flagLoaded = true;
    }

    async guardar(): Promise<void> {
        if (this.form.invalid) { return; }

        const data = this.form.value;

        try {
            let titulo: string;
            let mensaje: string;

            if (this.modoCreacion) {
                await this.perfilesService.createPerfil(data);
                titulo = 'Rol creado';
                mensaje = 'El rol se creó correctamente.';
            } else {
                await this.perfilesService.updatePerfil(this.perfil!._id, data);
                titulo = 'Rol actualizado';
                mensaje = 'Los datos del rol se guardaron correctamente.';
            }

            this.modalCustom.abrirPopup({
                titulo,
                mensaje,
                tipo: 'success',
                accionConfirmar: () => this.volverAlListado(),
                accionCerrar: () => this.volverAlListado(),
            });
        } catch {
            this.modalCustom.abrirPopup({
                titulo: 'Error al guardar',
                mensaje: 'Ocurrió un error al guardar el rol. Intente nuevamente.',
                tipo: 'error',
                accionConfirmar: () => this.volverAlListado(),
                accionCerrar: () => this.volverAlListado(),
            });
        }
    }

    private volverAlListado(): void {
        this.perfilesService.setPerfilSeleccionado(null);
        this.router.navigateByUrl('/roles-administracion');
    }

    cancelar(): void {
        this.volverAlListado();
    }
}
